import { useEffect, useState } from "react";
import api from "../../api/api";
import Offres from './../../Components/Modal/Offre';
import OffreCreate from "../../Components/Modal/OffreCreate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHotTubPerson, faPerson, faPersonBurst, faPersonCircleMinus, faPersonCirclePlus, faSubscript } from "@fortawesome/free-solid-svg-icons";

// Composant pour gérer les offres premium
const OffresPremium = () =>{

    const [offres, setOffres] = useState([])
    const [open, setOpen] = useState(false)
    const [creater, setCreater] = useState(false)
    const [selectedOffre, setSelectedOffre] = useState(null)

    useEffect(()=>{

        const getData = async ()=>{

            try {
                
                const data = await api.get('/offres');
                
                setOffres(data.data)
                console.log(data)
                
            } catch (error) {
                console.log(error)
            }
            
        }

        getData()
        
    }, [])
    
    return (
        
        <div className="p-6 mx-auto animate-fade max-w-7xl">
        {/* Titre et bouton de création */}
            <div className="flex items-center justify-between mb-6">
                <h2 className="text-3xl font-extrabold text-white">Offres Premium</h2>
                <button
                className="px-6 py-3 font-semibold text-white transition-all duration-200 bg-indigo-600 rounded-lg shadow-lg hover:bg-indigo-700 hover:ring-4 ring-indigo-300 focus:ring-indigo-500"
                onClick={() => setCreater(true)}
                >
                Créer une nouvelle offre
                </button>
            </div>

            {/* Description */}
            <p className="mb-8 text-lg text-gray-400">Liste des offres premium à modifier</p>

            {/* Conteneur des cartes */}
            <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-3">
                {
                    offres.map((item, idx)=>{
                        return (
                            <div 
                                key={idx} 
                                className="max-w-sm p-6 mb-6 transition-all duration-300 transform bg-gray-800 rounded-lg shadow-lg cursor-pointer hover:bg-gray-700 hover:shadow-xl hover:-translate-y-1"
                                onClick={() => {
                                    setOpen(true);
                                    setSelectedOffre(item);
                                }}
                            >
                                {/* Header de l'offre */}
                                <div className="flex items-center justify-between gap-10 mb-4">
                                    <div>
                                        <h3 className="text-lg font-bold text-white">{item.name}</h3>
                                        <div className="flex flex-row items-center gap-2">
                                            <div className="flex flex-row items-center gap-1">
                                                <FontAwesomeIcon icon={faPersonCirclePlus} color={"#0e9f6e"}/>
                                                <span className="text-sm font-medium text-green-500">
                                                    {item.premiumClient.filter((item)=>item.isValid).length}
                                                </span>    
                                            </div>

                                            <div className="flex flex-row items-center gap-1">
                                                <FontAwesomeIcon icon={faPersonCircleMinus} color="#f05252"/>
                                                <span className="text-sm font-medium text-red-500">
                                                    {item.premiumClient.filter((item)=>!item.isValid).length}
                                                </span>    
                                            </div>
                                        </div>
                                    </div>
                                    <p className="text-lg font-semibold text-blue-400">{item.price} XAF</p>
                                </div>

                                {/* Détails de la durée et cycle */}
                                <div className="flex items-center justify-between mb-4 text-gray-400">
                                    <p className="text-sm">
                                    Durée : <span className="font-medium text-gray-300">{item.duration}</span>
                                    </p>
                                    <p className="text-sm">
                                    Cycle : <span className="font-medium text-gray-300">{item.bilingCycle}</span>
                                    </p>
                                </div>

                                {/* Période d'essai et cycle */}
                                <div className="flex items-center justify-between mb-4 text-gray-400">
                                    <p className="text-sm">
                                    Période d'essai : <span className="font-medium text-gray-300">{item.trial_period}</span>
                                    </p>
                                    <p className="text-sm">
                                    Cycle : <span className="font-medium text-gray-300">{item.periodCycle}</span>
                                    </p>
                                </div>

                                {/* Détails des remises et boosts */}
                                <div className="flex items-center justify-between text-gray-400">
                                    <p className="text-sm">
                                    Remise : <span className="font-medium text-green-400">{item.discount} %</span>
                                    </p>
                                    <p className="text-sm">
                                    Boosts : <span className="font-medium text-gray-300">{item.nbBoost}</span>
                                    </p>
                                    <p className={`text-sm font-semibold ${item.isActif ? 'text-green-500' : 'text-red-500'}`}>
                                    {item.isActif ? 'Actif' : 'Inactif'}
                                    </p>

                                    <p className={`text-sm font-semibold ${item.isVisible ? 'text-green-500' : 'text-red-500'}`}>
                                    {item.isVisible ? 'Visible' : 'Invisible'}
                                    </p>
                                </div>
                            </div>

                        )
                    })
                }
            </div>

            {selectedOffre && <Offres
                data={selectedOffre}
                open={open}
                setOpen={setOpen}
            />}

            <OffreCreate
                open={creater}
                setOpen={setCreater}
            />
        </div>

          

          
        
      );
} 

export default OffresPremium